import React from 'react';
import { Button } from 'react-bootstrap';
import PropTypes from 'prop-types';

import AlertComponent from '../../../../../components/Alert';

const Bot = ({ tgBot, showEditButton, setOpenModal }) => (
  <div className="settings-notifications__block">
    <div className="settings-notifications__block-title">Telegram bot</div>
    {!tgBot || tgBot?.webhook_status === 0 ? (
      <Button onClick={() => setOpenModal('bot-telegram')}>Connect</Button>
    ) : (
      <>
        {tgBot?.token_revoked ? <AlertComponent type="danger" text={tgBot?.token_revoked_title || ''} /> : null }
        <div className="settings-notifications__block-body">
          <table style={{ width: '100%' }}>
            <thead>
              <tr>
                {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
                <th />
              </tr>
            </thead>
            <tbody>
              <tr className="settings-notifications__block-body--row">
                <td>
                  @
                  {tgBot.bot_name}
                </td>
                {showEditButton ? (
                  <td className="text-right">
                    <Button bsSize="xs" onClick={() => setOpenModal('edit-bot-telegram')}>Edit</Button>
                  </td>
                ) : null}
              </tr>
            </tbody>
          </table>
        </div>
      </>
    )}
  </div>

)

Bot.propTypes = {
  tgBot: PropTypes.object,
  showEditButton: PropTypes.bool,
  setOpenModal: PropTypes.func,
};

export default Bot;
